/* unplugin-vue-components disabled */import { render } from "./CustomerSeatingChart.vue?vue&type=template&id=7ac8b6d8&ts=true"
import script from "./CustomerSeatingChart.vue?vue&type=script&lang=ts"
export * from "./CustomerSeatingChart.vue?vue&type=script&lang=ts"

import "./CustomerSeatingChart.vue?vue&type=style&index=0&id=7ac8b6d8&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__